// src/config.js

const API_BASE_URL = 'https://tanuu08.pythonanywhere.com/';
// const API_BASE_URL = 'http://127.0.0.1:8000/';

export default API_BASE_URL;
